<template>
<ItpPage
  no-primary-button
  :closeButtonText="'Close'|gettext"
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="MeterEditor"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="meter"
      class="row"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpCol>
        <FieldsetMeterGeneralData
          :meter="meter"
          :formId="formId"
        >
        </FieldsetMeterGeneralData>
      </ItpCol>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save changes'|pgettext('Button')"
      type="submit"
      :form="forms.meter"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class MeterEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: Object,
  })
  meter!: object;

  @Watch('meter')
  onMeter(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("meter")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['formId', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          noPrimaryButton: true,
          closeButtonText: this.$fn.gettext("Close"),
          size: "md",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("Meter", "Edit General Information"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_9304_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_9304, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeComponent_9310_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_9310, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_crud_9308_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_9308, alias=save
    return {
      objectType: "meter",
      op: "upsert",
      data: this.meter,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_9304: actions.CloseModalAction;
    evh_7315092382398562_close_9303: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_9306: actions.CloseComponentAction;
    evh_2248226175642056_close_9305: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeComponent_9310: actions.CloseComponentAction;
    evh_1040167445267876_success_9309: actions.EventHandlerImpl;
    act_1040167445267876_crud_9308: actions.CRUDAction;
    evh_1040167445267876_submit_9307: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_9312: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_9311: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_9304 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_9304_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_9303 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_9304,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_9303],
      }
    );
    const act_2248226175642056_closeComponent_9306 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_9305 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_9306,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_9305],
      }
    );
    const act_1040167445267876_closeComponent_9310 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_9310_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_9309 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_9310,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_crud_9308 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_9308_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_9309],
      }
    );
    const evh_1040167445267876_submit_9307 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_9308,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_9307],
      }
    );
    const act_1419464017721962_closeComponent_9312 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_9311 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_9312,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_9311],
      }
    );
    return {
      act_7315092382398562_closeModal_9304,
      evh_7315092382398562_close_9303,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_9306,
      evh_2248226175642056_close_9305,
      evh_2248226175642056_close,
      act_1040167445267876_closeComponent_9310,
      evh_1040167445267876_success_9309,
      act_1040167445267876_crud_9308,
      evh_1040167445267876_submit_9307,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_9312,
      evh_1419464017721962_clickPreventStop_9311,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_crud_9308,
    }
  }
}

Vue.component("MeterEditor", MeterEditor);

</script>